import { render, staticRenderFns } from "./statistics-use.vue?vue&type=template&id=6c28ef59&scoped=true&"
import script from "./statistics-use.vue?vue&type=script&lang=js&"
export * from "./statistics-use.vue?vue&type=script&lang=js&"
import style0 from "./statistics-use.vue?vue&type=style&index=0&id=6c28ef59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c28ef59",
  null
  
)

export default component.exports